import React from 'react';
import { Formik, Form as FormikForm } from 'formik';
import * as Yup from 'yup';
import { Button, App as AntdApp} from 'antd';
import { TextField } from '../components/form/fields/TextField';  
import { getCurrentUser, setAuthSession} from '../utils/auth';
import { useNavigate } from 'react-router-dom';
import { User } from '../types/users.types';
import { themeConfig } from '../layout/theme';
import { navigateBack } from '../hooks/useBackNavigation';
import { userApi } from '../api/accountsApi';

const EditProfile: React.FC = () => {
  const { message } = AntdApp.useApp(); 
  const navigate = useNavigate();
  const userDetails =  getCurrentUser(); 
  const userId = userDetails?._id || ""; // Get logged-in user ID  
 

  // Validation schema
  const editProfileSchema = Yup.object().shape({
    fullName: Yup.string().required('Full name is required'),
    phone: Yup.string().required('Phone number is required'),
  });

  // Handle form submission
  const handleSubmit = async (values: Partial<User>) => {
    try {
      const payload = {
        fullName: values.fullName?.trim(),
        phone: values.phone?.trim(),        
        email: userDetails?.email, // Send only specific fields  
        role: userDetails?.role?._id || "",
        updatedBy: userId, // Assuming the user is updating their own profile
      };

      const {data:user} = await userApi.update(userId, payload); 
      const authData = userDetails?{...userDetails, fullName:user.fullName,phone:user.phone} : user; // Merge with existing user details
      setAuthSession(authData, false);
      message.success('Profile updated successfully.');
      navigateBack(navigate); // Redirect to the dashboard or another page
    } catch (error: any) {
      const err = error?.message || 'Failed to update profile';
      message.error(err);
    }
  };
 
  return (
    <div className="w-full h-full flex items-center justify-center">
      <div className="w-1/2 p-10 border border-gray-300 rounded-lg bg-white">
        <h1 className="text-center text-2xl font-bold text-gray-700 mb-6">Edit Your Profile</h1>
        <Formik
      initialValues={{
        fullName: userDetails?.fullName || '',
        email: userDetails?.email || '',
        phone: userDetails?.phone || '',
      }}
      validationSchema={editProfileSchema}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {({ isSubmitting }) => (
        <FormikForm autoComplete="off" className="px-4 pb-6 mx-auto w-full max-w-md">
          <div className="space-y-4">
            <TextField name="fullName" label="Full Name" placeholder="Enter your full name" />
            <TextField
              name="email"
              label="Email"
              placeholder="Enter your email"
              disabled // Email is always disabled
            />
            <TextField name="phone" label="Phone" placeholder="Enter your phone number" />
          </div>
          <div className="mt-6">
            <Button
              type="primary"
              htmlType="submit"
              className="w-full"
              style={{
                backgroundColor: themeConfig.token.colorPrimary,
                borderColor: themeConfig.token.colorPrimary,
                color: '#fff',
              }}
              loading={isSubmitting}
            >
              Save Changes
            </Button>
          </div>
        </FormikForm>
      )}
    </Formik>
      </div>
    </div>
  );
};

export default EditProfile;